import { render, staticRenderFns } from "./PointOfSaleTopBar.vue?vue&type=template&id=361fef46&scoped=true&"
import script from "./PointOfSaleTopBar.vue?vue&type=script&lang=js&"
export * from "./PointOfSaleTopBar.vue?vue&type=script&lang=js&"
import style0 from "./PointOfSaleTopBar.vue?vue&type=style&index=0&id=361fef46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361fef46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
